import React from 'react'
import './FinalExam.css'
import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';

function FinalExam() {
  const navigate = useNavigate();
  const { answerQuestion } = useSelector((state) => state);
  const { courses } = useSelector((state) => state);

  return (
    <div className='mb-5'>
      <Container fluid>
        <Row>
          <Col md={2}></Col>
          <Col md={7}>
            <div className="final-exam-card-wrapper">
              <div className="final-exam-card">
                <div className="card-content-exam">

                  <div className="exam-icon">🏆</div>

                  <h3 className="exam-title">الاختبار النهائي</h3>
                  <p className="exam-description">
                    اختبر معلوماتك ومهاراتك في جميع محاور البرنامج التدريبي (5 دروس)
                  </p>

                  {/* 🔥 زر يبدأ الاختبار مباشرة بدون شرط */}
                  <button 
                    className="exam-button" 
                    onClick={() => {
                      navigate("https://docs.google.com/forms/d/e/1FAIpQLScL7qouIq8ACSqmFPqMmWi4io-zVmEzWdnjTFJVYor5hd_Csw/viewform")
                    }}
                  >
                    ابدأ الاختبار
                  </button>

                </div>
              </div>
            </div>
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>
    </div>
  )
}

export default FinalExam
